import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 119DD58E-769B-47C2-9AB8-1671DEC4FE4A
 * name equal
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/equal.svg
 * tags
 * - Math 
 */
export const EqualIcon = createSvgIcon(<><path d="M19,10H5V8H19V10M19,16H5V14H19V16Z" /></>, 'EqualIcon');
export default EqualIcon